import React from 'react';
import ChoiceActionRow from "../components/ChoiceActionRow";
import SquareChoice from "../components/SquareChoice";

export const DefaultChoiceState = ({state, userId, setConfirmAction}) => {

    const actions = state.actions[userId];
    const findAction = imageName => actions.find(a => a.imageName && a.imageName.toLowerCase() === imageName);

    // Bonus for reaching 2 conservation points: shown as two big buttons so it stands out
    const improveAction = findAction("bonus_improve_action");
    const recruitVolunteer = findAction("bonus_recruit_volunteer");
    if (state.state === "DEFAULT_CHOICE" && actions.length === 2 && improveAction && recruitVolunteer) {
        return <SquareChoice
            title={"2 points de conservation !"}
            subtitle={"Choisissez votre bonus"}
            setConfirmAction={setConfirmAction}
            options={[
                {action: recruitVolunteer, label: "Recruter un bénévole", accent: "#3fa34d"},
                {action: improveAction, label: "Améliorer une carte action", accent: "#d98a1c"}
            ]}
        />;
    }

    let title = "C'est à vous de jouer !";

    if(state.state === "CHOOSE_EFFECTS"){
        if(state.actions[userId][state.actions[userId].length - 1].name === "Faire tous les effets dans l'ordre" ){
            title = "Choisissez l'ordre des effets à appliquer :";
        } else {
            title = "Choisissez un SEUL effet à appliquer :";
        }
    }


    return <div>
        <h2>
            {title}
        </h2>
        <div>
            {
                state.actions[userId].map((a, i) =>
                    <ChoiceActionRow key={a.name + "" + i} action={a} setConfirmAction={setConfirmAction}/>
                )
            }
        </div>
    </div>


}
export default DefaultChoiceState;
